import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=5e7265cd&scoped=true&"
import script from "./Config.vue?vue&type=script&lang=js&"
export * from "./Config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7265cd",
  null
  
)

component.options.__file = "Config.vue"
export default component.exports